export default "__VITE_ASSET__BMmjxVO6__"